import gsap from "gsap";


export default class TweenGroup
{
    private _tl: gsap.core.Timeline = null;


    public init(): void
    {
        this._tl = new gsap.core.Timeline();
        this._tl.smoothChildTiming = true;
        this._tl.autoRemoveChildren = true;
    }

    public end(): void
    {
        this._tl.kill();
        this._tl = null;
    }

    public pause(): void
    {
        this._tl.pause();
    }

    public resume(): void
    {
        this._tl.resume();
    }

    public add( tween: gsap.core.Tween | gsap.core.Timeline ): void
    {
        this._tl.add( tween, this._tl.time() + 0.001 );
        //this._tl.play( this._tl.time() );
    }

    public reset(): void
    {
        this._tl.kill();
        this._tl = new gsap.core.Timeline();
        this._tl.smoothChildTiming = true;
        this._tl.autoRemoveChildren = true;
    }
}